import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shipping-delivery-policy',
  templateUrl: './shipping-delivery-policy.component.html',
  styleUrls: ['./shipping-delivery-policy.component.css']
})
export class ShippingDeliveryPolicyComponent {
  constructor(private router: Router) { }
} 